var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-xs leading-4 font-normal text-dark-6 my-4"},[_vm._v("\n  "+_vm._s(_vm.$t(`SIDEBAR.${_vm.label}`))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }